<template>
  <b-card class="m-0">
    <!-- form -->
    <b-col md="12">
      <b-form>
        <validation-observer ref="simpleRules">
          <b-row>
            <!-- old password -->
            <b-col md="12">
              <validation-provider
                :name="$t('oldPassword')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group label-for="account-old-password">
                  <label
                    >{{ $t("oldPassword") }}<span class="required">*</span>
                  </label>

                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="account-old-password"
                      v-model="passwordValueOld"
                      :state="errors.length > 0 ? false : null"
                      name="old-password"
                      :type="passwordFieldTypeOld"
                      :placeholder="$t('oldPasswordPlaceholder')"
                    />
                    <b-input-group-append
                      :class="{ 'is-invalid': errors.length > 0 }"
                      is-text
                    >
                      <feather-icon
                        :icon="passwordToggleIconOld"
                        class="cursor-pointer"
                        @click="togglePasswordOld"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--/ old password -->
          </b-row>
          <b-row>
            <!-- new password -->
            <b-col md="12">
              <validation-provider
                :name="$t('newPassword')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group label-for="account-new-password">
                  <label
                    >{{ $t("newPassword") }}<span class="required">*</span>
                  </label>

                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="account-new-password"
                      v-model="newPasswordValue"
                      :type="passwordFieldTypeNew"
                      :state="errors.length > 0 ? false : null"
                      name="new-password"
                      :placeholder="$t('newPasswordPlaceholder')"
                    />
                    <b-input-group-append
                      is-text
                      :class="{ 'is-invalid': errors.length > 0 }"
                    >
                      <feather-icon
                        :icon="passwordToggleIconNew"
                        class="cursor-pointer"
                        @click="togglePasswordNew"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--/ new password -->
            <!-- retype password -->
            <b-col md="12">
              <validation-provider
                :name="$t('confirmNewPassword')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group label-for="account-retype-new-password">
                  <label
                    >{{ $t("confirmNewPassword")
                    }}<span class="required">*</span>
                  </label>

                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="account-retype-new-password"
                      v-model="RetypePassword"
                      :type="passwordFieldTypeRetype"
                      :state="errors.length > 0 ? false : null"
                      name="retype-password"
                      :placeholder="$t('confirmNewPasswordPlaceholder')"
                    />
                    <b-input-group-append
                      is-text
                      :class="{ 'is-invalid': errors.length > 0 }"
                    >
                      <feather-icon
                        :icon="passwordToggleIconRetype"
                        class="cursor-pointer"
                        @click="togglePasswordRetype"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--/ retype password -->
            <b-col cols="12">
              <small v-show="msgErrors" class="text-danger">{{
                msgErrors
              }}</small>
            </b-col>
            <!-- buttons -->
            <b-col cols="12">
            <small class="text-danger">
                {{ $t("noteChangePassword") }}

            </small>
          </b-col>

            <b-col cols="12" class="d-flex justify-content-center mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                style="min-width: 170px"
                class="mt-1 mr-1 round"
                @click="onSubmit"
                :disabled="isButtom"
              >
                {{ $t("saveChanges") }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                style="min-width: 170px"
                variant="outline-secondary"
                class="mt-1 round"
              >
                {{ $t("reset") }}
              </b-button>
            </b-col>
            <!--/ buttons -->
          </b-row>
        </validation-observer>
      </b-form>
    </b-col>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import useJwt from "@/auth/jwt/useJwt";
import { initialAbility } from "@/libs/acl/config";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    accountNew: { type: Boolean, default: false },
  },
  data() {
    return {
      passwordValueOld: "",
      newPasswordValue: "",
      RetypePassword: "",
      passwordFieldTypeOld: "password",
      passwordFieldTypeNew: "password",
      passwordFieldTypeRetype: "password",
      msgErrors: null,
      isButtom: true,
    };
  },
  watch: {
    newPasswordValue: function (o, n) {
      if (this.passwordValueOld == this.newPasswordValue) {
        this.isButtom = true;
        return (this.msgErrors = this.$i18n.t("errorComparePass"));
      }
      this.msgErrors = "";
    },
    RetypePassword: function (o, n) {
      if (
        this.newPasswordValue !== this.RetypePassword &&
        this.newPasswordValue != "" &&
        this.RetypePassword != ""
      ) {
        this.isButtom = true;
        return (this.msgErrors = this.$i18n.t("PassMatch"));
      }
      this.isButtom = false;
      this.msgErrors = "";
    },
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === "password"
        ? "EyeIcon"
        : "EyeOffIcon";
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === "password"
        ? "EyeIcon"
        : "EyeOffIcon";
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === "password"
        ? "EyeIcon"
        : "EyeOffIcon";
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld =
        this.passwordFieldTypeOld === "password" ? "text" : "password";
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew =
        this.passwordFieldTypeNew === "password" ? "text" : "password";
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype =
        this.passwordFieldTypeRetype === "password" ? "text" : "password";
    },
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            icon: "XIcon",
            variant: "danger",
            text: this.$i18n.t("notifyFormError"),
          },
        });
        return;
      }
      useJwt
        .put("changepass", {
          oldPass: this.passwordValueOld,
          newPass: this.newPasswordValue,
          confirmNewPass: this.RetypePassword,
        })
        .then((res) => {
          if (res.data.result == 1) {
            // Remove userData from localStorage
            // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
            localStorage.removeItem(
              useJwt.jwtConfig.storageRefreshTokenKeyName
            );

            // Remove userData from localStorage
            localStorage.removeItem("userData");

            // Reset ability
            this.$ability.update(initialAbility);
            this.$store.commit("appConfig/CHANGE_PASS", false);
            this.$router.replace("/auth/login").then(() => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: this.$i18n.t("success"),
                  icon: "CheckIcon",
                  variant: "success",
                  text: `Password change successful`,
                },
              });
            });
            return;
          }
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$i18n.t("error"),
              icon: "XIcon",
              variant: "danger",
              text: this.$i18n.t("errorPassOld"),
            },
          });
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$i18n.t("error"),
              icon: "XIcon",
              variant: "danger",
              text: this.$i18n.t("errorSystem"),
            },
          });
        });
    },
  },
};
</script>

<style>
.is-invalid .input-group-text {
  border: 1px solid #ea5455 !important;
}
</style>
